import React from "react";
import { Layout, PageHeader, Space, Button, Radio, Avatar, Divider, Card, DatePicker, Table, Row, Col } from "antd";
import { useState } from "react";
import { useEffect } from "react";
import moment from "moment"
import Spinner from "../../components/Layout/Spinner";
import _ from 'lodash';
import OverviewCard from "../../components/Card/OverviewKpiCard";
import DashboardService from "../../services/DashboardService";
import RatingLayout from "../../components/Layout/RatingLayout";
import { useHistory } from "react-router-dom";
import { getLocalISODate } from "../../utils";


const { Content } = Layout;


const DeliveryDashboard = () => {
    const [isLoading, setLoading] = useState(true);
    const history = useHistory();

    const [size, setSize] = useState('week');
    const [data, setData] = useState({});
    const [showPopular, setShowPopular] = useState(true);
    const [fromDate, setFromDate] = useState(moment().startOf('week').format('DD-MM-YYYY'));
    const [toDate, setToDate] = useState(moment().endOf('week').format('DD-MM-YYYY'));


   const getData = () => {
    DashboardService.getDeliveryDashboard(moment(fromDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(toDate, 'DD-MM-YYYY').format('YYYY-MM-DD')).then((res)=>{
      setData(res);
      setLoading(false);
    });
  }

  useEffect(()=>{
    getData();
  },[toDate, fromDate]);

 
    const onFilterDateChange = (date, dateString, field) => {
      if(field === 'starDate'){
        setFromDate(moment(dateString, 'MMM DD, YYYY'));
      } else {
        setToDate(moment(dateString, 'MMM DD, YYYY'));
      }
        setSize('');
      };
      const onPeriodChange = (e) => {
        setSize(e.target.value);
        setFromDate(moment().startOf(e.target.value).format('DD-MM-YYYY'));
        setToDate(moment().endOf(e.target.value).format('DD-MM-YYYY'))
      }
      const onReset = () => {
        setSize('week');
        setFromDate(moment().startOf('week').format('DD-MM-YYYY'));
        setToDate(moment().endOf('week').format('DD-MM-YYYY'))
      }
      const column2 = [{
        title: "NAME OF ITEM",
        dataIndex: "name",
        key: "name",
        render: (_, record) => {
          return (
            <div className="flex">
              <Avatar shape="square" size={50} src={record?.item_photo}
                        style={{ marginRight: "20px" }} />
              <div className="item-name">{record?.item_name}</div>
            </div>
          );
        },
      },
      {
        title: "UNITS SOLD",
        dataIndex: "units_sold",
        key: "units_sold"
      },
      {
          title: "%AGE OF SALE",
          dataIndex: "percentange_of_sale",
          key: "percentange_of_sale",
          render: (_, record) => {
            return (
              <div style={{ display: "flex", justifyContent:"center" }} >
                <div  className="name_text red">
                  {record?.percentange_of_sale?.toFixed(2)}%
                </div>
              </div>
            );
          },
        }
      ];
      const getColor = (rating) => {
        switch (rating) {
          case 1:
            return "#BD1B04"
          case 2:
            return "#BD5204"
          case 3:
            return "#D7C200"
          case 4:
            return "#8DA400"
          case 5:
            return "#0B8617"
          default:
            return "#0B8617"
        }
  };
    return (
        <Layout className="u-page-layout tips-layout kpi_dboard">
            <Content className="w-full page-padding">
            <Space className="w-full" direction="vertical">
                <PageHeader
                    title={`Orders (${getLocalISODate()})`}
                    className="page-header"
                    extra={[
                    <>
                        {/* <div className="flex" style={{ border: size ? "0px" : "2px solid red"}}>
                        <div className=""><DatePicker name="starDate" allowClear={false} onChange={(date, dString)=>onFilterDateChange(date, dString, "starDate")} value={moment(fromDate, "DD-MM-YYYY")} format='MMM DD, YYYY' /></div>
                        <div className=""><DatePicker name="endDate" allowClear={false} onChange={(date, dString)=>onFilterDateChange(date, dString, 'endDate')} value={moment(toDate, "DD-MM-YYYY")} format='MMM DD, YYYY' /></div>
                        <Button type={size ? "dashed" : "primary" } onClick={onReset}>Reset</Button>
                        </div>
                        <div>
                        <Radio.Group value={size} onChange={onPeriodChange}>
                        <Radio.Button value="week">This Week</Radio.Button>
                        <Radio.Button value="month">This Month</Radio.Button>
                        <Radio.Button value="year">This Year</Radio.Button>
                        </Radio.Group>
                    </div> */}
                     <Button
                                    type="primary"
                                    onClick={() => history.push("/delivery/manage-orders")}
                                  >
                                    Manage Orders
                                  </Button>
                    </>
                    ]}
                />
                </Space>
                    <div className="text-left flex flex_wrap">
                        <div >
                            <OverviewCard title={data?.total_orders} subTitle="Total orders recieved today" className="min_kpi_card_size" />
                        </div>
                        <div >
                            <OverviewCard title={data?.orders_with_unassigned_drives} subTitle="Orders with unassigned drivers" className="min_kpi_card_size" />
                        </div>
                        <div >
                            <OverviewCard title={data?.undelivered_orders} subTitle="Orders inprogress" className="min_kpi_card_size" />
                        </div>
                        <div >
                            <OverviewCard title={data?.fulfilled_orders} subTitle="Completed orders" className="min_kpi_card_size" />
                        </div>
                    </div>

                    <Divider />

                    <PageHeader
                        title="Drivers"
                        className="page-header"
                        extra={[
                          <Button
                                          type="primary"
                                          onClick={() => history.push("/delivery/manage-drivers")}
                                        >
                                          Manage Drivers
                                        </Button>
                        ]}
                    />
                    <div className="text-left flex flex_wrap">
                        <div >
                            <OverviewCard title={data?.total_drivers} subTitle="Total delivery drivers" className="min_kpi_card_size" />
                        </div>
                        <div >
                            <OverviewCard title={data?.total_drivers} subTitle="Delivery drivers on duty" className="min_kpi_card_size" />
                        </div>
                    </div>

                    <Divider />

                    <PageHeader
                        title="KPIs, tips, tables"
                        className="page-header"

                    />
                <Row className="text-left tips-card-margin" gutter={[16, 16]}>
                <Col xs={24} md={11} lg={11}>
                        <Card
                        title="Branch wise sales"
                        bordered={false}
                        style={{ width: "100%", height: "100%"}}
                        >
                        <div>
                            {
                            data?.popular_items_by_branch?.map((item)=>{
                                return <div className="server_items">
                                <div className="flex">
                                <Avatar shape="square" size={50} src={item?.popular_item?.item_photo}
                                    style={{ marginRight: "20px" }} />
                                <div >
                                    <div className="item-name">{item.name}</div>
                                    <div className="item-units"> Unit sold: <span className="unit">{item.popular_item?.units_sold}</span></div>
                                </div>
                                </div>
                                <div className="item-price">
                                ${item.popular_item?.total_price || 0}
                                </div>
                            </div>
                            })
                            }

                        </div>
                        </Card>
                        </Col>
                        <Col xs={24} md={11} lg={11}>
                        <Card
                        title={showPopular? <div>
                            <span className="red">Popular Items </span>
                            <span onClick={()=>{setShowPopular(false)}} className="cursor-pointer">| Least Popular Items</span>
                            </div> :
                        <div>
                            <span onClick={()=>{setShowPopular(true)}} className="cursor-pointer">Popular Items | </span>
                            <span className="red">Least Popular Items</span>
                        </div>}
                        bordered={false}
                        style={{ width: "100%", height: "100%"}}
                        >
                        <div>
                        <Table
                            columns={column2}
                            dataSource={data && data[showPopular ? 'popular_items' : 'unpopular_items']||[]}
                            className="popular_list-table"
                            pagination={false}
                        />
                        </div>
                        </Card>
                    </Col>
                    </Row>
                    <Row className="text-left tips-card-margin" gutter={[16, 16]}>
                    <Col xs={24} md={11} lg={11}>
                        <Card
                        title="Top Rated Drivers"
                        bordered={false}
                        style={{ width: "100%", height: "100%"}}
                        >
                        <div>{
                            data?.top_rated_drivers?.map((item)=>{
                            return (<div className="server_items">
                            <div className="flex">
                                <Avatar size={50} src={item.photo_url}
                                style={{ marginRight: "20px" }} />
                                <div >
                                <div className="item-name">{item.name}</div>
                                <div className="item-units"> Orders Delivered: <span className="unit">{item.total_orders_delivered}</span></div>
                                </div>
                            </div>
                            <div className="item-price">
                                <RatingLayout rating={item.rating} color={getColor((_.round(item.average_rating)))} />
                            </div>
                            </div>)
                            })
                            }</div>
                        </Card>
                        </Col>
                        <Col xs={24} md={11} lg={11}>
                        <Card
                        title="Average Delivery Time"
                        bordered={false}
                        style={{ width: "100%", height: "100%"}}
                        >
                        <div>{
                            data?.avg_delivery_times?.map((item)=>{
                            return (
                            <div className="flex space-between p-1 px-2">
                                <div className="padding-l">{item.name}:</div>
                                <div className="pr-24 font-500">{_.round(item?.average_delivery_time || 0, 1)} min</div>
                            </div>)
                            })
                            }</div> 
                        </Card>
                    </Col>
                    </Row>
            </Content>


            {isLoading &&
                <Spinner />
            }
        </Layout>
    );
};

export default DeliveryDashboard;
